import { Control, Controller, FieldError, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ReactSelect from 'react-select';

import { DropdownIndicator, FormError } from 'coreOld/elements';

interface IProps {
  name: string;
  value?: string | number | string[] | number[];
  defaultValue?: string | number | string[] | number[];
  placeholder?: string;
  menuIsOpen?: boolean;
  customStyles?;
  control?: Control<FieldValues, object>;
  isMulti?: boolean;
  mapDataToFilters: (options, onChange) => void;
  showDropdownIcon?: boolean;
  disabled?: boolean;
  editable?: boolean;
  getValue?;
  getLabel?;
  onChange?;
  options?;
  isLoadingOptions?: boolean;
  onKeyDown?;
  isClearable?: boolean;
  error?: FieldError | string;
  showFieldError?: boolean;
}

const SelectWithControllerView = ({
  name,
  control,
  value,
  defaultValue,
  customStyles,
  options,
  isLoadingOptions = false,
  placeholder,
  menuIsOpen,
  isMulti = false,
  showDropdownIcon = true,
  disabled = false,
  editable = true,
  getLabel,
  getValue,
  mapDataToFilters,
  onKeyDown,
  isClearable = false,
  error,
  showFieldError = false,
}: IProps) => {
  const { t } = useTranslation();

  const dropdownIndicator = showDropdownIcon && !disabled ? DropdownIndicator : null;

  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <ReactSelect
            {...field}
            onChange={(option) =>
              isMulti ? mapDataToFilters(option, field.onChange) : field.onChange(getValue(option))
            }
            components={{ DropdownIndicator: dropdownIndicator }}
            value={
              (value || field.value) && options.find((option) => getValue(option) === field.value)
            }
            getOptionValue={getValue}
            getOptionLabel={getLabel}
            isMulti={isMulti}
            isClearable={isClearable}
            styles={customStyles}
            options={options}
            placeholder={disabled && !editable ? '-' : placeholder}
            menuIsOpen={menuIsOpen}
            onKeyDown={(event) => onKeyDown && onKeyDown(event)}
            isDisabled={disabled}
            noOptionsMessage={() =>
              isLoadingOptions ? t('messageLoading') : t('messageNoOptionsAvailable')
            }
            menuPortalTarget={document.body}
            closeMenuOnSelect
          />
        )}
      />

      {error && showFieldError && <FormError error={error} />}
    </>
  );
};

export default SelectWithControllerView;
